import type { TableColumn } from "@/components/widgets/Revision/types";

export const getPeriodName = (value: TableColumn) =>
	value.type === "Q"
		? `${value.type}${value.quarter}/${value.year % 100}`
		: `${value.type}/${value.year % 100}`;
